<template>
  <div class="banner-card-header">
    <button
      class="btn btn-sm bg-gradient-fvf btn-volver"
      type="button"
      @click.prevent="$emit('go-back')"
    >
      Volver
    </button>

    <img
      v-if="!loading && bannerUrl"
      :src="bannerUrl"
      alt="banner"
      class="image-fluid"
    />
    <div v-else class="d-flex justify-content-center p-4">
      <img
        src="../../core_assets/img/ccdlogolite.png"
        alt="..."
        class="img-fluid"
        style="height: 200px; width: auto"
      />
    </div>

    <div class="banner-gradient-overlay"></div>
  </div>
</template>

<script setup>
defineProps({
  bannerUrl: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: true,
  },
});

defineEmits(['go-back']);
</script>

<style scoped>
.banner-card-header {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  border-radius: 0;
}

.banner-card-header img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: top;
  display: block;
}

.btn-volver {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  border-radius: 20px;
}

.banner-gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  border-radius: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
  z-index: 2;
}
</style>
